import { defineMessages } from 'react-intl';

type MessageKeys = 'previewNotAvailable';

const message: Record<MessageKeys, { id: string; defaultMessage: string; description?: string }> =
	defineMessages({
		previewNotAvailable: {
			id: 'ai-mate.file-preview-modal.preview-not-available',
			defaultMessage: 'Preview not available for this file type',
			description: 'Message shown when file preview cannot be displayed',
		},
	});

export default message;
